import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import SubPaywall from '../../DeviationViews/Full/_partials/SubPaywall';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { DeviationTypes } from '../../types/deviation';
import { isExtendedDeviationFullyLoaded } from '../redux/helpers';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import LiteratureTextualContent from '../../DeviationViews/TextualContent/Literature';
import s from './MobileDeviationPage.scss';
var MobileDeviationPage = function (_a) {
    var deviation = _a.deviation;
    var updatedStage = useFlag('mobile_stage_height');
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var deviationType = getDeviationType(deviation);
    var isJournal = deviationType === DeviationTypes.JOURNAL;
    var isLiterature = deviationType === DeviationTypes.LITERATURE;
    var isJournalOrLit = isJournal || isLiterature;
    var isCommission = deviationType === DeviationTypes.COMMISSION;
    var isStatus = deviationType === DeviationTypes.STATUS;
    var isNotPoll = deviationType !== DeviationTypes.POLL;
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isSubscribedButBlocked = _b.isSubscribedButBlocked, needsSubscription = _b.needsSubscription;
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ArtStage, { className: updatedStage
                ? undefined
                : classnames(isNotPoll && s['stage-content'], isJournal && s['journal-stage-content'], isCommission && s['commission-stage-content'], isStatus && s['status-stage-content']), deviation: deviation }),
        React.createElement(ActionBar, { deviation: deviation }),
        isLiterature && (React.createElement("div", { className: s['lit-content'] },
            React.createElement(LiteratureTextualContent, { deviation: deviation }))),
        React.createElement(PanelPopup, { deviation: deviation, actionBarType: "primary", className: s['large-popover-uplifted'] }),
        React.createElement(Details, { contentClassName: s['details'], deviation: deviation }),
        React.createElement(UserGiftSaleBanner, { user: deviation.author }),
        isJournalOrLit && isBlocked && (React.createElement(SubPaywall, { deviation: deviation, showImage: false })),
        isExtendedLoaded ? (React.createElement(React.Fragment, null,
            !isBlocked && (React.createElement(Comments, { deviation: deviation, className: s['comments'] })),
            !isBlocked && !!tier && (React.createElement(TierUpsell, { className: s['upsell'], deviation: deviation })),
            React.createElement("div", { className: s['sidebar'] },
                React.createElement(Sidebar, { deviation: deviation })))) : (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" })),
        isBlocked && !!tier && (React.createElement(TierUpsell, { className: s['upsell'], deviation: deviation }))));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
//# sourceMappingURL=MobileDeviationPage.js.map